
import React from 'react';


export const attributes = {};
export default function() {
  return (
    <div>
      <h1>Snooker Calculator</h1>
<p>Application allows you to calculate players score and remaining score on table.</p>
<p>If you run the app after several balls were potted you can use <strong>Set Start data</strong> screen to update the starting score.</p>
<p>There are some <em>limitations</em> now.</p>
<ul>
<li>In <strong>Set Start data</strong> menu you can not specify that the next ball is coloured. So app will
always start with red ball as ball on.</li>
<li>Fauls where red was potted are not implemented. If such situtation happens you need to
use <em>Start data</em> to reduce the number of reds</li>
<li>Free Ball is always red. Faul situations on last stage (e.g. you have to pot brown and get snookered after faul) are not present.</li>
</ul>
<p>If you have any suggestion on how to fix the limitations above or other bugreports or (<em>prefferable</em>) fixes - you can start an
issue or pull request on <a href="https://github.com/IBestuzhev/snooker-calc">project's GitHub</a></p>

    </div>
  );
};


// WEBPACK FOOTER //
// ./src/content/welcome.md